export interface PhoneCountry {
  iso: string;
  name: string;
  dialCode: string;
}

export const PHONE_COUNTRIES: PhoneCountry[] = [
  { iso: 'us', name: 'United States', dialCode: '+1' },
  { iso: 'ca', name: 'Canada', dialCode: '+1' },
  { iso: 'gb', name: 'United Kingdom', dialCode: '+44' },
  { iso: 'af', name: 'Afghanistan', dialCode: '+93' },
  { iso: 'al', name: 'Albania', dialCode: '+355' },
  { iso: 'dz', name: 'Algeria', dialCode: '+213' },
  { iso: 'ar', name: 'Argentina', dialCode: '+54' },
  { iso: 'am', name: 'Armenia', dialCode: '+374' },
  { iso: 'au', name: 'Australia', dialCode: '+61' },
  { iso: 'at', name: 'Austria', dialCode: '+43' },
  { iso: 'az', name: 'Azerbaijan', dialCode: '+994' },
  { iso: 'bh', name: 'Bahrain', dialCode: '+973' },
  { iso: 'bd', name: 'Bangladesh', dialCode: '+880' },
  { iso: 'by', name: 'Belarus', dialCode: '+375' },
  { iso: 'be', name: 'Belgium', dialCode: '+32' },
  { iso: 'bz', name: 'Belize', dialCode: '+501' },
  { iso: 'bo', name: 'Bolivia', dialCode: '+591' },
  { iso: 'ba', name: 'Bosnia and Herzegovina', dialCode: '+387' },
  { iso: 'br', name: 'Brazil', dialCode: '+55' },
  { iso: 'bg', name: 'Bulgaria', dialCode: '+359' },
  { iso: 'kh', name: 'Cambodia', dialCode: '+855' },
  { iso: 'cm', name: 'Cameroon', dialCode: '+237' },
  { iso: 'cl', name: 'Chile', dialCode: '+56' },
  { iso: 'cn', name: 'China', dialCode: '+86' },
  { iso: 'co', name: 'Colombia', dialCode: '+57' },
  { iso: 'cr', name: 'Costa Rica', dialCode: '+506' },
  { iso: 'hr', name: 'Croatia', dialCode: '+385' },
  { iso: 'cu', name: 'Cuba', dialCode: '+53' },
  { iso: 'cy', name: 'Cyprus', dialCode: '+357' },
  { iso: 'cz', name: 'Czech Republic', dialCode: '+420' },
  { iso: 'dk', name: 'Denmark', dialCode: '+45' },
  { iso: 'do', name: 'Dominican Republic', dialCode: '+1' },
  { iso: 'ec', name: 'Ecuador', dialCode: '+593' },
  { iso: 'eg', name: 'Egypt', dialCode: '+20' },
  { iso: 'sv', name: 'El Salvador', dialCode: '+503' },
  { iso: 'ee', name: 'Estonia', dialCode: '+372' },
  { iso: 'et', name: 'Ethiopia', dialCode: '+251' },
  { iso: 'fi', name: 'Finland', dialCode: '+358' },
  { iso: 'fr', name: 'France', dialCode: '+33' },
  { iso: 'ge', name: 'Georgia', dialCode: '+995' },
  { iso: 'de', name: 'Germany', dialCode: '+49' },
  { iso: 'gh', name: 'Ghana', dialCode: '+233' },
  { iso: 'gr', name: 'Greece', dialCode: '+30' },
  { iso: 'gt', name: 'Guatemala', dialCode: '+502' },
  { iso: 'ht', name: 'Haiti', dialCode: '+509' },
  { iso: 'hn', name: 'Honduras', dialCode: '+504' },
  { iso: 'hk', name: 'Hong Kong', dialCode: '+852' },
  { iso: 'hu', name: 'Hungary', dialCode: '+36' },
  { iso: 'is', name: 'Iceland', dialCode: '+354' },
  { iso: 'in', name: 'India', dialCode: '+91' },
  { iso: 'id', name: 'Indonesia', dialCode: '+62' },
  { iso: 'ir', name: 'Iran', dialCode: '+98' },
  { iso: 'iq', name: 'Iraq', dialCode: '+964' },
  { iso: 'ie', name: 'Ireland', dialCode: '+353' },
  { iso: 'il', name: 'Israel', dialCode: '+972' },
  { iso: 'it', name: 'Italy', dialCode: '+39' },
  { iso: 'jm', name: 'Jamaica', dialCode: '+1' },
  { iso: 'jp', name: 'Japan', dialCode: '+81' },
  { iso: 'jo', name: 'Jordan', dialCode: '+962' },
  { iso: 'kz', name: 'Kazakhstan', dialCode: '+7' },
  { iso: 'ke', name: 'Kenya', dialCode: '+254' },
  { iso: 'kw', name: 'Kuwait', dialCode: '+965' },
  { iso: 'kg', name: 'Kyrgyzstan', dialCode: '+996' },
  { iso: 'la', name: 'Laos', dialCode: '+856' },
  { iso: 'lv', name: 'Latvia', dialCode: '+371' },
  { iso: 'lb', name: 'Lebanon', dialCode: '+961' },
  { iso: 'ly', name: 'Libya', dialCode: '+218' },
  { iso: 'lt', name: 'Lithuania', dialCode: '+370' },
  { iso: 'lu', name: 'Luxembourg', dialCode: '+352' },
  { iso: 'my', name: 'Malaysia', dialCode: '+60' },
  { iso: 'mv', name: 'Maldives', dialCode: '+960' },
  { iso: 'mx', name: 'Mexico', dialCode: '+52' },
  { iso: 'md', name: 'Moldova', dialCode: '+373' },
  { iso: 'mn', name: 'Mongolia', dialCode: '+976' },
  { iso: 'me', name: 'Montenegro', dialCode: '+382' },
  { iso: 'ma', name: 'Morocco', dialCode: '+212' },
  { iso: 'mm', name: 'Myanmar', dialCode: '+95' },
  { iso: 'np', name: 'Nepal', dialCode: '+977' },
  { iso: 'nl', name: 'Netherlands', dialCode: '+31' },
  { iso: 'nz', name: 'New Zealand', dialCode: '+64' },
  { iso: 'ni', name: 'Nicaragua', dialCode: '+505' },
  { iso: 'ng', name: 'Nigeria', dialCode: '+234' },
  { iso: 'mk', name: 'North Macedonia', dialCode: '+389' },
  { iso: 'no', name: 'Norway', dialCode: '+47' },
  { iso: 'om', name: 'Oman', dialCode: '+968' },
  { iso: 'pk', name: 'Pakistan', dialCode: '+92' },
  { iso: 'ps', name: 'Palestine', dialCode: '+970' },
  { iso: 'pa', name: 'Panama', dialCode: '+507' },
  { iso: 'py', name: 'Paraguay', dialCode: '+595' },
  { iso: 'pe', name: 'Peru', dialCode: '+51' },
  { iso: 'ph', name: 'Philippines', dialCode: '+63' },
  { iso: 'pl', name: 'Poland', dialCode: '+48' },
  { iso: 'pt', name: 'Portugal', dialCode: '+351' },
  { iso: 'pr', name: 'Puerto Rico', dialCode: '+1' },
  { iso: 'qa', name: 'Qatar', dialCode: '+974' },
  { iso: 'ro', name: 'Romania', dialCode: '+40' },
  { iso: 'ru', name: 'Russia', dialCode: '+7' },
  { iso: 'sa', name: 'Saudi Arabia', dialCode: '+966' },
  { iso: 'rs', name: 'Serbia', dialCode: '+381' },
  { iso: 'sg', name: 'Singapore', dialCode: '+65' },
  { iso: 'sk', name: 'Slovakia', dialCode: '+421' },
  { iso: 'si', name: 'Slovenia', dialCode: '+386' },
  { iso: 'so', name: 'Somalia', dialCode: '+252' },
  { iso: 'za', name: 'South Africa', dialCode: '+27' },
  { iso: 'kr', name: 'South Korea', dialCode: '+82' },
  { iso: 'es', name: 'Spain', dialCode: '+34' },
  { iso: 'lk', name: 'Sri Lanka', dialCode: '+94' },
  { iso: 'sd', name: 'Sudan', dialCode: '+249' },
  { iso: 'se', name: 'Sweden', dialCode: '+46' },
  { iso: 'ch', name: 'Switzerland', dialCode: '+41' },
  { iso: 'sy', name: 'Syria', dialCode: '+963' },
  { iso: 'tw', name: 'Taiwan', dialCode: '+886' },
  { iso: 'tj', name: 'Tajikistan', dialCode: '+992' },
  { iso: 'tz', name: 'Tanzania', dialCode: '+255' },
  { iso: 'th', name: 'Thailand', dialCode: '+66' },
  { iso: 'tt', name: 'Trinidad and Tobago', dialCode: '+1' },
  { iso: 'tn', name: 'Tunisia', dialCode: '+216' },
  { iso: 'tr', name: 'Turkey', dialCode: '+90' },
  { iso: 'tm', name: 'Turkmenistan', dialCode: '+993' },
  { iso: 'ug', name: 'Uganda', dialCode: '+256' },
  { iso: 'ua', name: 'Ukraine', dialCode: '+380' },
  { iso: 'ae', name: 'United Arab Emirates', dialCode: '+971' },
  { iso: 'uy', name: 'Uruguay', dialCode: '+598' },
  { iso: 'uz', name: 'Uzbekistan', dialCode: '+998' },
  { iso: 've', name: 'Venezuela', dialCode: '+58' },
  { iso: 'vn', name: 'Vietnam', dialCode: '+84' },
  { iso: 'ye', name: 'Yemen', dialCode: '+967' },
  { iso: 'zm', name: 'Zambia', dialCode: '+260' },
  { iso: 'zw', name: 'Zimbabwe', dialCode: '+263' }
];
